const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + (props.className || '')}
    >
      <path
        d="M13.2184 24.9793H9.77012C8.96552 24.9793 8.27586 25.6763 8.27586 26.4896C8.27586 27.3029 8.96552 28 9.77012 28H13.2184C14.023 28 14.7126 27.3029 14.7126 26.4896C14.7126 25.6763 14.023 24.9793 13.2184 24.9793ZM21.7241 21.3776H20.8046V12.3154C20.8046 7.55187 17.3563 3.71784 12.8736 3.02075V1.51037C12.8736 0.697096 12.2989 0 11.4943 0C10.6897 0 10 0.697096 10 1.51037V3.02075C5.51724 3.71784 2.06897 7.66805 2.06897 12.3154V21.3776H1.37931C0.574713 21.3776 0 22.0747 0 22.888C0 23.7012 0.689655 24.3983 1.49425 24.3983H3.67816H19.5402H21.8391C22.6437 24.3983 23.3333 23.7012 23.3333 22.888C23.3333 22.0747 22.5287 21.3776 21.7241 21.3776ZM4.94253 21.3776V12.3154C4.94253 8.71369 7.81609 5.80913 11.3793 5.80913C14.9425 5.80913 17.8161 8.71369 17.8161 12.3154V21.3776H4.94253Z"
      />
    </svg>
  );
};
